import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import AOS from 'aos';
import 'aos/dist/aos.css';
import './assets/main.less';
import './assets/fonts.less';
import axios from 'axios';
// import Vue from 'vue'
// createApp(App).use(router).mount('#app')


const app = createApp(App);
// 初始化 AOS
AOS.init({
    offset: 200, // 元素触发动画的偏移量（px）
    duration: 1500, // 动画持续时间（ms）
    easing: 'ease-in-out', // 动画缓动函数
    once: false, // 是否只触发一次动画
    mirror: true, // 是否在滚动回到元素时触发动画
    debounceDelay:50, // 防抖延迟（ms）
    throttleDelay: 99, // 节流延迟（ms）
});


app.config.globalProperties.$http = axios; // 将 Axios 挂载到 Vue 实例
app.use(router).mount('#app');